module.exports = __webpack_public_path__ + "img/squre.450677cc.png";